import service from './axios';

// 获取账户列表
export const fetchAccounts = (params) => {
  return service({
    method: 'get',
    url: '/manage/accounts',
    params
  });
};

// 新增账户
export const addAccount = (data) => {
  return service({
    method: 'post',
    url: '/manage/accounts',
    data
  });
};

// 获取账户详情
export const fetchAccountDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/accounts/${id}`,
  });
};

// 更新账户
export const updateAccount = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/accounts/${id}`,
    data
  });
};

// 删除账户
export const deleteAccount = (id) => {
  return service({
    method: 'delete',
    url: `/manage/accounts/${id}`,
  });
};

// 获取角色列表
export const fetchRoles = () => {
  return service({
    method: 'get',
    url: '/manage/roles',
    params: {
      all: true
    }
  });
};

// 获取角色列表（带分页）
export const fetchRolesWithPagination = (params) => {
  return service({
    method: 'get',
    url: '/manage/roles',
    params
  });
};

// 新增角色
export const addRole = (data) => {
  return service({
    method: 'post',
    url: '/manage/roles',
    data
  });
};

// 获取角色详情
export const fetchRoleDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/roles/${id}`,
  });
};

// 更新角色
export const updateRole = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/roles/${id}`,
    data
  });
};

// 删除角色
export const deleteRole = (id) => {
  return service({
    method: 'delete',
    url: `/manage/roles/${id}`,
  });
};